import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatTabGroup, MatTabNav } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { requireCheckboxesToBeCheckedValidator } from 'src/app/Modules/idms/core/atleastOneChecked.validator';
import { UniqueNameValidation } from 'src/app/Modules/management/core/Validators/unique-name.validator';
import { LineNumberFormat, LineNumberFormatSection, LineNumberFormatSectionType } from 'src/app/Modules/management/models/instance/line-number-format.model';
import { CompareNumbers } from 'src/app/Modules/settings/core/Validators/compare.Validator';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';

@Component({
    selector: 'app-line-number-format-details',
    templateUrl: './line-number-format-details.component.html',
    styleUrls: ['./line-number-format-details.component.scss'],
})
export class LineNumberFormatDetailsComponent implements OnInit, OnDestroy {
    @Input() defaultLineNumberFormatSectionTypes: LineNumberFormatSectionType[];
    @Input()
    set linenumberFormat(linenumberFormat: LineNumberFormat) {
        if (linenumberFormat) {
            // let div = Array.prototype.slice.call(document.getElementsByClassName('mat-tab-list'));
            // let element = div[0] as HTMLLIElement;
            // element.style.transform = 'translateX(0px) !important';
            if (linenumberFormat?.sections?.length <= 3) {
                this.pagination = true;
            } else {
                this.pagination = false;
            }
            this._linenumberFormat = linenumberFormat;
        }
    }
    get linenumberFormat() {
        return this._linenumberFormat;
    }

    @Input()
    set linerNumberFormatFormGroup(value: UntypedFormGroup) {
        this._linerNumberFormatFormGroup = value;
        this.checkAllowFree();
    }
    get linerNumberFormatFormGroup(): UntypedFormGroup {
        return this._linerNumberFormatFormGroup;
    }

    @Input() isModal: boolean;
    @Input() selectedTabNo: number;
    @Input() nameList: string[];
    @ViewChild('tab') matTabGroupNav: MatTabNav;
    @ViewChild('tab') matTabGroup: MatTabGroup;
    @Input() currentInstanceId: string;
    @Output() tabIndexChanged: EventEmitter<number> = new EventEmitter<number>();
    @Output() allowFreeForm: EventEmitter<LineNumberFormat> = new EventEmitter<LineNumberFormat>();
    @Output() formetNameChanged: EventEmitter<any> = new EventEmitter<any>();

    pagination: boolean;
    destroy$ = new Subject();
    _linerNumberFormatFormGroup: UntypedFormGroup;
    _linenumberFormat: LineNumberFormat;
    _linenumberFormatSection: LineNumberFormatSection[] = [];

    isZeroCharacterAllowed: boolean = false;
    constructor(
        public ngbActiveModal: NgbActiveModal,
        private ngbModal: NgbModal,
        private managementApiService: ManagementApiService,
        private activatedRoute: ActivatedRoute,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastService: CustomToastService,
        private cd: ChangeDetectorRef,
        private userUtilityService: UserUtilityService,
        private customValidator: CustomValidatorService
    ) {
        this.isModal = false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes?.linenumberFormat?.currentValue) {
            this.checkSectionValidation(changes?.linerNumberFormatFormGroup?.currentValue);
        }
    }

    checkSectionValidation(form: any) {
        const sectionArray = this.getSectionFormControlArray();
        const insulationSection = this.defaultLineNumberFormatSectionTypes.find((s) => s.index == 5);
        const targetSection = sectionArray.controls.find((ctrl) => ctrl.get('sectionType')?.value === insulationSection.lineNumberFormatSectionTypeId);
        const minCharControl = targetSection?.get('minMaxGroup.minChar');
        if (minCharControl) {
            minCharControl.setValidators([Validators.required, Validators.min(0)]);
            minCharControl.updateValueAndValidity();
        }
    }

    ngOnInit(): void {
        this._linenumberFormatSection = this._linenumberFormat.sections;
        this._linerNumberFormatFormGroup
            .get('name')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
                this.formetNameChanged.emit(res);
            });

        if (this._linenumberFormatSection.length > 0 && this._linenumberFormatSection[0]?.type?.index == 5) {
            this.isZeroCharacterAllowed = false;
            this.cd.detectChanges();
            this.setMinCharValidator(0);
        } else {
            this.isZeroCharacterAllowed = true;
            this.cd.detectChanges();
            this.setMinCharValidator(1);
        }
    }

    checkAllowFree() {
        let sectionArray = this.linerNumberFormatFormGroup.controls['section'] as UntypedFormArray;
        let exampleArray = this.linerNumberFormatFormGroup.controls['exampleName'] as UntypedFormArray;
        let sectionNameList = sectionArray.controls.map((control) => control.value.name);
        if (!this._linenumberFormat.sections.length && !this.linenumberFormat?.allowFreeForm) {
            let resp = new UntypedFormGroup({
                lineNumberFormatSectionId: new UntypedFormControl('', []),
                index: new UntypedFormControl('', []),
                name: new UntypedFormControl('', [Validators.required, UniqueNameValidation(sectionNameList)]),
                minMaxGroup: new UntypedFormGroup(
                    {
                        minChar: new UntypedFormControl('', [Validators.required, Validators.min(this.isZeroCharacterAllowed ? 0 : 1), Validators.max(12)]),
                        maxChar: new UntypedFormControl('', [Validators.required, Validators.max(12)]),
                    },
                    CompareNumbers()
                ),
                checkboxGroup: new UntypedFormGroup(
                    {
                        allowAlpha: new UntypedFormControl(false, []),
                        allowNumeric: new UntypedFormControl(false, []),
                    },
                    requireCheckboxesToBeCheckedValidator()
                ),
                sectionType: new UntypedFormControl('', Validators.required),
            });
            sectionArray.push(resp);
            exampleArray.push(new UntypedFormControl({ value: '', disabled: true }, []));
            this._linenumberFormat.sections.push(resp.value);
            this.cd.detectChanges();
        }
        this._linerNumberFormatFormGroup
            .get('allowFreeCheck')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
                if (res) {
                    if (sectionArray.length) {
                        sectionArray.clear();
                        exampleArray.clear();
                        this._linenumberFormat.sections = [];
                        this.linenumberFormat = this._linenumberFormat;
                        this.allowFreeForm.emit(this.linenumberFormat);
                    }
                }
                if (!res) {
                    if (sectionArray.controls.length != this._linenumberFormat.sections.length) {
                        this._linenumberFormat.sections.map((x: any) => {
                            let resp = new UntypedFormGroup({
                                lineNumberFormatSectionId: new UntypedFormControl(x.lineNumberFormatSectionId, []),
                                index: new UntypedFormControl(x.index, []),
                                name: new UntypedFormControl(x.name, [Validators.required, UniqueNameValidation(sectionNameList)]),
                                minMaxGroup: new UntypedFormGroup(
                                    {
                                        minChar: new UntypedFormControl(x.minLength ? x.minLength : x.minMaxGroup?.minChar, [
                                            Validators.required,
                                            Validators.min(this.isZeroCharacterAllowed ? 0 : 1),

                                            Validators.max(12),
                                        ]),
                                        maxChar: new UntypedFormControl(x.maxLength ? x.maxLength : x.minMaxGroup?.maxChar, [
                                            Validators.required,
                                            Validators.max(12),
                                        ]),
                                    },
                                    CompareNumbers()
                                ),
                                checkboxGroup: new UntypedFormGroup(
                                    {
                                        allowAlpha: new UntypedFormControl(x?.allowAlpha ? x?.allowAlpha : x.checkboxGroup?.allowAlpha, []),
                                        allowNumeric: new UntypedFormControl(x?.allowNumeric ? x?.allowNumeric : x.checkboxGroup?.allowNumeric, []),
                                    },
                                    requireCheckboxesToBeCheckedValidator()
                                ),
                                sectionType: new UntypedFormControl(
                                    x?.type?.lineNumberFormatSectionTypeId ? x?.type?.lineNumberFormatSectionTypeId : x?.sectionType,
                                    Validators.required
                                ),
                            });
                            let exampleControl = new UntypedFormControl({ value: '', disabled: true }, []) as UntypedFormControl;
                            exampleArray.push(exampleControl);
                            this.updateLineFormatString(resp, exampleControl, 'checkBox');
                            sectionArray.push(resp);
                        });
                    }
                    this._linenumberFormatSection = [];
                    if (!this._linenumberFormat.sections.length) {
                        let resp = new UntypedFormGroup({
                            lineNumberFormatSectionId: new UntypedFormControl('', []),
                            index: new UntypedFormControl('', []),
                            name: new UntypedFormControl('', [Validators.required, UniqueNameValidation(sectionNameList)]),
                            minMaxGroup: new UntypedFormGroup(
                                {
                                    minChar: new UntypedFormControl('', [
                                        Validators.required,
                                        Validators.min(this.isZeroCharacterAllowed ? 0 : 1),
                                        Validators.max(12),
                                    ]),
                                    maxChar: new UntypedFormControl('', [Validators.required, Validators.max(12)]),
                                },
                                CompareNumbers()
                            ),
                            checkboxGroup: new UntypedFormGroup(
                                {
                                    allowAlpha: new UntypedFormControl(false, []),
                                    allowNumeric: new UntypedFormControl(false, []),
                                },
                                requireCheckboxesToBeCheckedValidator()
                            ),
                            sectionType: new UntypedFormControl('', Validators.required),
                        });
                        sectionArray.push(resp);
                        exampleArray.push(new UntypedFormControl({ value: '', disabled: true }, []));
                        this._linenumberFormat.sections.push(resp.value);
                        this.cd.detectChanges();
                    }
                }
            });
    }

    getSectionFormControlArray() {
        return this.linerNumberFormatFormGroup.get('section') as UntypedFormArray;
    }

    getExampleFormControlArray() {
        return this.linerNumberFormatFormGroup.get('exampleName') as UntypedFormArray;
    }

    // * add new section in line number format
    addNewLineNumberSection() {
        let sectionFormArray = this.linerNumberFormatFormGroup.get('section') as UntypedFormArray;
        let sectionNameList = sectionFormArray.controls.map((control) => control.value.name);
        let exampleFormArray = this.linerNumberFormatFormGroup.get('exampleName') as UntypedFormArray;
        sectionFormArray.push(
            new UntypedFormGroup({
                index: new UntypedFormControl(this._linenumberFormat.sections.length + 1, []),
                name: new UntypedFormControl('', [Validators.required, UniqueNameValidation(sectionNameList)]),
                minMaxGroup: new UntypedFormGroup(
                    {
                        minChar: new UntypedFormControl('', [Validators.required, Validators.min(this.isZeroCharacterAllowed ? 0 : 1), Validators.max(12)]),
                        maxChar: new UntypedFormControl('', [Validators.required, Validators.max(12)]),
                    },
                    CompareNumbers()
                ),
                checkboxGroup: new UntypedFormGroup(
                    {
                        allowAlpha: new UntypedFormControl(false, []),
                        allowNumeric: new UntypedFormControl(false, []),
                    },
                    requireCheckboxesToBeCheckedValidator()
                ),
                sectionType: new UntypedFormControl('', Validators.required),
            })
        );
        exampleFormArray.push(new UntypedFormControl({ value: '', disabled: true }, []));
        this._linenumberFormat.sections.push(new LineNumberFormatSection());
        this.linerNumberFormatFormGroup.markAsDirty();
        this.selectedTabNo = this._linenumberFormat.sections.length - 1;
        this.cd.detectChanges();
    }

    // * tab change event handler
    tabChangeEvent(event) {
        this.tabIndexChanged.emit(event.index);
    }

    // * update example strings based on the input value changes
    updateLineFormatString(currentFormGroup: UntypedFormGroup, exampleFormControl: UntypedFormControl, index: string) {
        let stringLength = currentFormGroup.get('minMaxGroup').get('maxChar').value;
        let allowAlpha = currentFormGroup.get('checkboxGroup').get('allowAlpha').value;
        let allowNumeric = currentFormGroup.get('checkboxGroup').get('allowNumeric').value;
        let stringType = allowAlpha && allowNumeric ? 3 : allowAlpha ? 1 : 2;

        switch (index) {
            case 'input':
                if (currentFormGroup.get('minMaxGroup').valid && stringLength) {
                    exampleFormControl.setValue(this.lineNumberFormatGeneration(stringType, stringLength));
                } else {
                    exampleFormControl.setValue('Invalid Values');
                }
                break;

            case 'checkBox':
                if (currentFormGroup.get('checkboxGroup').valid && stringLength) {
                    exampleFormControl.setValue(this.lineNumberFormatGeneration(stringType, stringLength));
                } else {
                    exampleFormControl.setValue('Invalid Values');
                }
                break;
        }
    }

    // * helper method to generate the random string
    lineNumberFormatGeneration(stringType: number, stringLength: number) {
        let result = '';
        switch (stringType) {
            case 1: // * allow alpha only
                result = Array.apply(0, Array(stringLength))
                    .map(function () {
                        return (function (charset) {
                            return charset.charAt(Math.floor(Math.random() * charset.length));
                        })('AB');
                    })
                    .join('');
                break;

            case 2: // * allow number only
                result = Array.apply(0, Array(stringLength))
                    .map(function () {
                        return (function (charset) {
                            return charset.charAt(Math.floor(Math.random() * charset.length));
                        })('12');
                    })
                    .join('');
                break;

            case 3: // * allow alpha numeric
                result = Array.apply(0, Array(stringLength))
                    .map(function () {
                        return (function (charset) {
                            return charset.charAt(Math.floor(Math.random() * charset.length));
                        })('AB12');
                    })
                    .join('');
                break;
        }

        return result;
    }

    // * add line number format
    addLineNumberFormat() {
        this._linenumberFormat.name = this.linerNumberFormatFormGroup.get('name').value;
        this._linenumberFormat.allowFreeForm = this.linerNumberFormatFormGroup.get('allowFreeCheck').value;
        this._linenumberFormat.isDefault = this.linerNumberFormatFormGroup.get('defaultCheck').value;
        this._linenumberFormat.sections = this.linerNumberFormatFormGroup.value.section.map((section, index) => {
            return {
                name: section.name,
                index: index + 1,
                lineNumberFormatSectionTypeId: section.sectionType,
                allowAlpha: section.checkboxGroup.allowAlpha ? section.checkboxGroup.allowAlpha : false,
                allowNumeric: section.checkboxGroup.allowNumeric ? section.checkboxGroup.allowNumeric : false,
                minLength: this.isZeroCharacterAllowed ? 0 : section.minMaxGroup.minChar,

                maxLength: section.minMaxGroup.maxChar,
            };
        });
        this.ngbActiveModal.close(this._linenumberFormat);
    }

    // * delete line number format sections
    deleteLineNumberSection(section: LineNumberFormatSection, formGroup: UntypedFormGroup) {
        let dialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.modalMessage = section.name
            ? `Are you sure you want to delete <strong>${section.name}</strong>?`
            : 'Are you sure you want to delete this item?';

        dialogRef.result
            .then((res) => {
                if (res) {
                    let payload;
                    if (section.lineNumberFormatSectionId) {
                        let index = this.getSectionFormControlArray().controls.findIndex(
                            (control) => control.value.name.toLowerCase().replace(' ', '') == section.name.toLowerCase().replace(' ', '')
                        );
                        if (index !== -1) {
                            this._linenumberFormat.sections.forEach((item: LineNumberFormatSection) => {
                                if (item.lineNumberFormatSectionId == section.lineNumberFormatSectionId) {
                                    payload = [
                                        {
                                            lineNumberFormatId: this._linenumberFormat.lineNumberFormatId,
                                            name: this._linenumberFormat.name,
                                            isDefault: this._linenumberFormat.isDefault,
                                            allowFreeForm: this._linenumberFormat.allowFreeForm,
                                            sections: [
                                                {
                                                    active: false,
                                                    lineNumberFormatSectionId: item.lineNumberFormatSectionId,
                                                },
                                            ],
                                        },
                                    ];
                                }
                            });
                            this.ngxUiLoaderService.start();
                            this.managementApiService
                                .saveLineNumberFormat(this.activatedRoute.snapshot.paramMap.get('id') || this.currentInstanceId, payload)
                                .subscribe((res) => {
                                    this.ngxUiLoaderService.stop();
                                    if (res.success) {
                                        this.getSectionFormControlArray().removeAt(index);
                                        this._linenumberFormat.sections.splice(index, 1);
                                        this.getExampleFormControlArray().removeAt(index);
                                        this.customToastService.successToast('Section Deleted Successfully!');
                                    } else if (res.isCustom) {
                                        this.userUtilityService.errorModelPopup(res.message);
                                    }
                                });
                        }
                    } else if (section.name) {
                        const index = this.getSectionFormControlArray().controls.findIndex((row) => row.value.name === section.name);
                        if (index !== -1) {
                            this.getSectionFormControlArray().removeAt(index);
                            this.getExampleFormControlArray().removeAt(index);
                            this._linenumberFormat.sections.pop();
                            this.customToastService.successToast('Section Deleted Successfully!');
                        }
                    } else {
                        this.getSectionFormControlArray().removeAt(this.getSectionFormControlArray().controls.length - 1);
                        this.getExampleFormControlArray().removeAt(this.getExampleFormControlArray().controls.length - 1);
                        this._linenumberFormat.sections.pop();
                        this.customToastService.successToast('Section Deleted Successfully!');
                    }
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    onKeyPress(event: KeyboardEvent) {
        this.customValidator.validateKeyPress(event);
    }

    dropdownSelectionChange(event: MatSelectChange): void {
        const selectedId = event.value;
        const selectedSection = this.defaultLineNumberFormatSectionTypes.find((s) => s.lineNumberFormatSectionTypeId === selectedId);

        if (selectedSection.index == 5) {
            this.isZeroCharacterAllowed = false;
            this.cd.detectChanges();
            this.setMinCharValidator(0);
        } else {
            this.isZeroCharacterAllowed = true;
            this.cd.detectChanges();
            this.setMinCharValidator(1);
        }
    }

    private setMinCharValidator(minValue: number) {
        const minCharControl = this.getSectionFormControlArray().at(0).get('minMaxGroup.minChar');

        if (minCharControl) {
            minCharControl.setValidators([Validators.required, Validators.min(minValue)]);
            minCharControl.updateValueAndValidity();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
